import { ifAuthenticated } from "../util/auth";

import Library from "../components/content/library";
import Input from "../components/partials/input";
import Search from "../components/partials/search";
import BlueLoader from "../components/partials/blue-loader";
import WhiteLoader from "../components/partials/white-loader";
import InputLoader from "../components/partials/input-loader";
import PageLoader from "../components/partials/page-loader";

export const libraryRoutes = {
  path: "/library",
  component: Library,
  children: [
    {
      path: "",
      component: Input
    },
    {
      path: "/search",
      component: Search
    },
    {
      path: "/white-loading",
      component: WhiteLoader
    },
    {
      path: "/blue-loading",
      component: BlueLoader
    },
    {
      path: "/input-loading",
      component: InputLoader
    },
    {
      path: "/page-loading",
      component: PageLoader
    }
  ],
  beforeEnter: ifAuthenticated
};
